"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledListItem = void 0;
var _ListItem = require("./ListItem");
// TODO: in v9, move styled() from ListItem.jsx to here
var StyledListItem = _ListItem.ListItem;
exports.StyledListItem = StyledListItem;